import getLangOriginal from 'I18n/utils/getLang';
import { LANGUAGES } from '../constants/TopFilterConstants';

/**
 * We want to make sure we limit the languages to the ones we support
 * If the users language is not supported we default to 'en'
 */
const getLang = () => {
  var _LANGUAGES$map$find;
  const lang = getLangOriginal().toLowerCase();
  return (_LANGUAGES$map$find = LANGUAGES.map(v => v.toLowerCase()).find(value => value === lang)) !== null && _LANGUAGES$map$find !== void 0 ? _LANGUAGES$map$find : 'en';
};
export default getLang;